import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M145-146q-32 0-56-23-23-24-23-56v-510q0-33 23-56 24-24 56-24h670q33 0 56 24 24 23 24 56v510q0 32-24 56-23 23-56 23H145Zm670-521L502-459l-11 5q-5 2-11 2t-11-2l-11-5-313-208v442h670v-442ZM480-517l331-218H150l330 218ZM145-667v9-48 1-30 29-1 49-9 442-442Z"/>',
  f: '<path d="M145-146q-32 0-56-23-23-24-23-56v-510q0-33 23-56 24-24 56-24h670q33 0 56 24 24 23 24 56v510q0 32-24 56-23 23-56 23H145Zm335-306q6 0 11-2l11-5 301-199q5-3 8-9 4-6 4-14 0-16-14-25-15-10-30 0L480-517 190-706q-15-9-30-1t-15 25q0 7 4 14 4 6 9 10l300 199 11 5q5 2 11 2Z"/>',
};

export default data;
